//import config from "@/config";
//import storage from "./storage";
import axios from 'axios';
//const zlib = require('zlib');
export default {
	 
	console(options){
		// if(config.debug){
		// 	console.log("<<===============================================>>");
		// 	console.log("request start");
		// 	console.log("header" + JSON.stringify(options.header));
		// 	console.log("method: " + options.method + " URL: " + options.url);
		// 	console.log("data: " + JSON.stringify(options.data));
		// 	console.log("request end");
		// 	console.log("<<===============================================>>");
		// } 
	},
	
	send(options={}){
		//options.url = config.uni_app_web_api_url + '' + options.url;
		options.method = options.method || "GET";
		  
		//let users =null; // storage.getJson("users");
		var authToken ="";
		if(users != null){
			authToken = users.userkey;
		} ;
		options.header = {
			"Auth-Token" : authToken,
			'content-type':'application/x-www-form-urlencoded'
		};
		 
		//this.console(options);
		return new Promise((resolve, reject) =>{
			uni.request(options).then(data=>{
				var [error, res]  = data;
				//console.log("res:"+JSON.stringify(res));
				if(error != null){
					reject(error);
				}else{
					//if(res.data.status == '-1001'){
					//if(res.data.success == false){
						uni.hideLoading();
						//uni.navigateTo({
						//    url: '/pages/public/login'
						//});
				
					//}else{
						resolve(res.data); 
					//}
				}
			});
		});
	},	
	get(url="",data={}){
		console.log("request().get().url="+ url) ;
		return this.sendget({
			url: url,
			data: data,
			method: "GET"
		});
	},	
	post(url="",data={}){
		return this.sendpost({
			url: url,
			data: data,
			method: "POST"
		});
	},
	sendget(options={}){
		//let users =null; // storage.getJson("users");
		var authToken ="";
		//if(users != null){
		//	authToken = users.userkey;
		//} ;
		options.header = {
			"Auth-Token" : authToken,
			'content-type':'application/x-www-form-urlencoded'
		};
	    //console.log("options1:"+JSON.stringify(options));		  
		return new Promise((resolve, reject) =>{ 
			axios.get(options.url, {headers:options.header ,params: options.data}).then((res) => {  
				if(res.data){
					resolve(res.data);
				}else{
					reject(error); 
				} 
			}) 
			.catch((err) => { 
				console.log(err); 
			}); 
		});
	},
	sendpost(options={}){
		var authToken ="";
		// if(users != null){
		// 	authToken = users.userkey;
		// } ;
		options.header = {
			"Auth-Token" : authToken,
			'content-type':'application/json'
		};
		//'content-type':'application/x-www-form-urlencoded'
		//'Content-Type': 'application/json'  
		return new Promise((resolve, reject) =>{
			axios.post(options.url,options.data,{headers:options.header}).then((res) => {
				if(res.data){
					resolve(res.data);
				}else{
					reject(error); 
				} 
			}) 
			.catch((err) => { 
				console.log(err); 
			}); 
			 
		});
	}
};